var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5.16667C8.84802 5.16667 4.66669 9.348 4.66669 14.5C4.66669 19.652 8.84802 23.8333 14 23.8333C19.152 23.8333 23.3334 19.652 23.3334 14.5C23.3334 9.348 19.152 5.16667 14 5.16667ZM17.7334 15.4333H14.9334V18.2333C14.9334 18.7467 14.5134 19.1667 14 19.1667C13.4867 19.1667 13.0667 18.7467 13.0667 18.2333V15.4333H10.2667C9.75335 15.4333 9.33335 15.0133 9.33335 14.5C9.33335 13.9867 9.75335 13.5667 10.2667 13.5667H13.0667V10.7667C13.0667 10.2533 13.4867 9.83333 14 9.83333C14.5134 9.83333 14.9334 10.2533 14.9334 10.7667V13.5667H17.7334C18.2467 13.5667 18.6667 13.9867 18.6667 14.5C18.6667 15.0133 18.2467 15.4333 17.7334 15.4333Z",
    fill: "white",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.01e0f38084cf9c594b379bfca7384fe7.svg";
export { ForwardRef as ReactComponent };